import React, { Component, Fragment } from 'react';
import {
  StyleEditor,
  StyleEditorIcon,
  IconContainer,
  Overlay,
  colors,
} from './StyledComponents';
import ColorPicker from './ColorPicker';
import Events from './events'

class Editor extends Component {
  componentDidMount () {  
    Events.on('closeColorPicker', this.hidePickers)
  }
  componentWillUnmount () {
    Events.off('closeColorPicker', this.hidePickers)
  }
  hidePickers = () => {
    this.setState({ showTextEditor: false, showBgEditor: false })
    if (this.props.styleEditing) {
      this.props.stopEditingStyle()
    }
  }
  state = {
    showTextEditor: false,
    showBgEditor: false
  };
  togglePicker = (open, close) => {
    this.setState({ [open]: !this.state[open], [close]: false }, () => {
      if (this.state.showTextEditor) {
        Events.emit('closeStyleManager')
      }
    });
  }
  toggleStyle = (style, value) => {
    const styleObj = {
      ...this.props.style,
      [style]: value || !this.props.style[style],
    };
    if (this.props.styleEditing) {
      this.props.updateStyle(styleObj)
    }
    this.props.setStyle(styleObj);
  };
  render() {
    const { style, colorsUsed, bgColorsUsed, styleEditing } = this.props;
    const { showBgEditor, showTextEditor } = this.state
    return (
      <div>
        <StyleEditor overflow={showTextEditor} styleEditing={styleEditing}>
          <IconContainer 
            color={style.c} 
            onClick={() => this.togglePicker('showTextEditor', 'showBgEditor')}
            borderLeft
          >
            <StyleEditorIcon img={'text-color.png'}/>
          </IconContainer>
           
          {['bold', 'italic', 'underline'].map(type => (
            <IconContainer
              color={style[type.slice(0, 1)] ? style.c : colors.lightGray}
              borderColor={style.c}
              boldSelected={style.c && style.b && type === 'bold'}
              onClick={() => this.toggleStyle(type.slice(0, 1))}
            >
              <StyleEditorIcon img={`${type}.png`} />
            </IconContainer>
          ))}
          <IconContainer 
            color={style.bg} 
            borderColor={style.c}
            onClick={() => this.togglePicker('showBgEditor', 'showTextEditor')}
            borderRight
          >
            <StyleEditorIcon img={'fill-color.png'}/>
          </IconContainer>
          {showTextEditor && (
            <Fragment>
              <ColorPicker
                colorsUsed={colorsUsed}
                onChange={color => this.toggleStyle('c', color)}
                toggle={this.toggleColorPicker}
                style={this.props.style}
                left={-135}
                prop={'c'}
              />
            </Fragment>
          )}
          {showBgEditor && (
            <Fragment>
              <ColorPicker
                colorsUsed={bgColorsUsed}
                onChange={color => this.toggleStyle('bg', color)}
                toggle={this.toggleBackgroundColorPicker}
                style={this.props.style}
                left={110}
                prop={'bg'}
              />
            </Fragment>
          )}
        </StyleEditor>
        { (showTextEditor || showBgEditor || styleEditing) && <Overlay onClick={() => this.hidePickers()} /> }
      </div>
    );

  }
}

export default Editor;
